import React from "react";
import { Link } from "react-router-dom";
import "../../assets/css/WhyChooseUs.css";

const whyChooseItems = [
  {
    icon: "fas fa-user-check",
    title: "Client-Focused Solutions",
    description:
      "Every organisation has unique regulatory challenges. Our solutions are customised to match the specific requirements, structure and objectives of each client.",
  },
  {
    icon: "fas fa-briefcase",
    title: "Practical Business Advice",
    description:
      "Our recommendations are legally sound while remaining commercially viable, practical and aligned with your business goals.",
  },
  {
    icon: "fas fa-clock",
    title: "Timely Compliance",
    description:
      "We proactively monitor statutory deadlines and help ensure that every regulatory obligation is completed accurately and on time.",
  },
  {
    icon: "fas fa-user-tie",
    title: "Experienced Professionals",
    description:
      "Our multidisciplinary professionals possess comprehensive knowledge of corporate, commercial, secretarial and regulatory laws.",
  },
  {
    icon: "fas fa-shield-alt",
    title: "Risk Mitigation",
    description:
      "We identify compliance gaps and regulatory risks before they develop into legal liabilities, penalties or operational disruption.",
  },
  {
    icon: "fas fa-laptop-code",
    title: "Technology-Driven Practice",
    description:
      "Modern compliance management systems help us deliver faster execution, better monitoring, improved accuracy and greater transparency.",
  },
  {
    icon: "fas fa-user-lock",
    title: "Complete Confidentiality",
    description:
      "Client information, business records and sensitive corporate documents are handled with the highest level of professional confidentiality.",
  },
  {
    icon: "fas fa-handshake",
    title: "Long-Term Professional Association",
    description:
      "We aim to become strategic compliance partners who support your organisation throughout every stage of its business journey.",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="home-why-area">
      <span className="home-why-shape home-why-shape-one"></span>
      <span className="home-why-shape home-why-shape-two"></span>

      <div className="container">
        <div className="row align-items-end g-4 home-why-heading-row">
          <div className="col-xl-7 col-lg-7">
            <div className="home-why-heading" data-aos="fade-right">
              <span className="home-why-subtitle">
                Why Choose Us
              </span>

              <h2>
                Professional advisory that protects your business and supports
                sustainable growth.
              </h2>
            </div>
          </div>

          <div className="col-xl-5 col-lg-5">
            <div className="home-why-intro" data-aos="fade-left">
              <p>
                Choosing the right professional advisor is essential for
                effective compliance, responsible governance and long-term
                corporate success.
              </p>

              <div className="home-why-intro-highlight">
                <span>
                  <i className="fas fa-check"></i>
                </span>

                <p>
                  Practical, reliable and business-focused professional support.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row g-4">
          {whyChooseItems.map((item, index) => (
            <div
              className="col-xl-3 col-lg-4 col-md-6"
              key={item.title}
              data-aos="fade-up"
              data-aos-delay={(index % 4) * 80}
            >
              <article className="home-why-card">
                <div className="home-why-card-top">
                  <span className="home-why-icon">
                    <i className={item.icon}></i>
                  </span>

                  <span className="home-why-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>

                <h3>{item.title}</h3>

                <p>{item.description}</p>

                <span className="home-why-card-bottom">
                  <span className="home-why-line"></span>

                  <i className="fas fa-arrow-right"></i>
                </span>
              </article>
            </div>
          ))}
        </div>

        <div className="home-why-cta" data-aos="zoom-in">
          <span className="home-why-cta-shape"></span>

          <div className="home-why-cta-icon">
            <i className="fas fa-balance-scale"></i>
          </div>

          <div className="home-why-cta-content">
            <span>Trusted Corporate Advisory Partner</span>

            <h3>
              Need reliable guidance for compliance, governance or corporate
              legal matters?
            </h3>

            <p>
              Speak with our professionals for practical solutions tailored to
              your organisation.
            </p>
          </div>

          <div className="home-why-cta-actions">
            <Link to="/contact-us" className="home-why-primary-btn">
              Request Consultation
              <i className="fas fa-arrow-right"></i>
            </Link>

            <Link to="/services" className="home-why-secondary-btn">
              Explore Services
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;